<template>
    <div>
        <div class="card-body">
            <el-form label-position="left" label-width="100px">
                <div class="card" v-for="applyDetail in $parentInfo.studentPeriod.applyReasons.applyDetails" :key="applyDetail.id">
                    <el-row :span="20" >
                        <el-col :span="20">
                            <el-form-item label="请假原因:">
                                <el-input v-model="applyDetail.reason"
                                          disabled></el-input>
                            </el-form-item>
                            <el-form-item label="个人请假类型:">
                                <el-select
                                        v-model="applyDetail.reason_type_id"
                                        placeholder="请选择"
                                        disabled>
                                    <el-option
                                            v-for="item in status_types"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="请假凭据:">
                                <img v-for="(studentApplyCredential,index) in applyDetail.studentApplyCredential"
                                     :key="index" :src="studentApplyCredential.credential" alt=""
                                     style="width: 150px;height: 150px"
                                     @click="handleShowCredentialDetail(studentApplyCredential.credential)">
                                <el-dialog
                                        title="凭据图片"
                                        :visible.sync="dialogVisible"
                                        :modal="false"
                                        width="50%">
                                    <img :src="credential" alt="" style="height: 100%;width: 100%">
                                    <span slot="footer" class="dialog-footer">
                                    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                                </span>
                                </el-dialog>
                            </el-form-item>
                            <el-form-item label="班主任备注:">
                                <el-input v-model="applyDetail.teacher_remark" type="textarea" :rows="1"></el-input>
                            </el-form-item>
                        </el-col>

                    </el-row>
                </div>
                <el-row :span="20">
                    <el-col :span="20">
                        <el-form-item label="请假类型:">
                            <el-select
                                    v-model="use_status_type"
                                    placeholder="请选择">
                                <el-option
                                        v-for="item in status_types"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="处理结果:">
                            <el-select
                                    v-model="status"
                                    placeholder="请选择">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" align="right">
                <el-button type="primary" size="small" @click="handleAbsentClass()"
                           :loading="$parentInfo.studentPeriod.leavingPeriod.button_loading">保存
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AskForLeave",
        data() {
            return {
                status: '',
                options: [
                    {
                        value: 'leaving',
                        label: '申请通过'
                    },
                    {
                        value: 'return',
                        label: '拒绝申请'
                    },
                ],
                use_status_type:'',
                credential: '',
                dialogVisible: false,
                status_types:[
                    {
                        value:1,
                        label:'个人原因'
                    },
                    {
                        value:2,
                        label:'病假'
                    },
                    {
                        value:3,
                        label:'个人社会实践'
                    },
                    {
                        value:4,
                        label:'学校集体活动'
                    },
                ],
                note:'',
            }
        },
        props: {
            classPlan_id: {
                default: 0,
            },
            student_id: {
                default: 0,
            },
            classPlanStudent_id: {
                default: 0,
            },
            classPlanStudent_status: {},
            status_type:{
                default: 0,
            },
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.status = '';
            this.use_status_type=this.status_type
        },
        methods: {
            handleAbsentClass() {
                this.$parentInfo.studentPeriod.leavingPeriod.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'askForApplyPeriod', {
                    'classPlanStudent_id': this.classPlanStudent_id,
                    'applyDetails':this.$parentInfo.studentPeriod.applyReasons.applyDetails,
                    'status_type': this.use_status_type,
                    'status':this.status,
                    'student_id': this.$parentInfo.student_id,
                });
            },
            handleShowCredentialDetail(credential) {
                this.credential = credential;
                this.dialogVisible = true;
            },
        },
    }
</script>

<style scoped>

</style>
